import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './TherapeuticAreas.css';
import { translations } from '../translations';
// Import images as modules
import koza1 from '../images/1stpage2ndsection/koza1.webp';
import kosa2 from '../images/1stpage2ndsection/kosa2.webp';
import koza3 from '../images/1stpage2ndsection/koza3.webp';
import regenativeMedicine4 from '../images/1stpage2ndsection/regenativemedicine4.webp';

// Map image paths to imported modules
const imageMap = {
  '/images/1stpage2ndsection/koza1.webp': koza1,
  '/images/1stpage2ndsection/kosa2.webp': kosa2,
  '/images/1stpage2ndsection/koza3.webp': koza3,
  '/images/1stpage2ndsection/regenativemedicine4.webp': regenativeMedicine4,
};

const TherapeuticAreas = ({ language = 'bg' }) => {
  const [selectedArea, setSelectedArea] = useState(null);
  const navigate = useNavigate();

  // Get areas from translation file and map images
  const areas = translations[language].therapeuticAreasData.map(area => ({
    ...area,
    image: imageMap[area.image] || area.image,
  }));

  const handleLearnMore = (e, area) => {
    e.preventDefault();
    setSelectedArea(area);
  };

  const closeModal = () => {
    setSelectedArea(null);
  };

  const handleBookConsultation = () => {
    navigate('/contact');
  };

  return (
    <section className="therapeutic-areas-section">
      <div className="section-header">
        <h2 className="section-title">
          {translations[language].therapeuticAreas.sectionTitle}
        </h2>
      </div>
      <div className="therapeutic-areas-container">
        {areas.map((area) => (
          <div 
            key={area.id} 
            className="area-card"
            style={{ backgroundImage: `url(${area.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
          >
            <div className="area-content">
              <div className="area-id">{area.id}</div>
              <h3 className="area-title">{area.title}</h3>
              <h4 className="area-subtitle">{area.subtitle}</h4>
              <button onClick={(e) => handleLearnMore(e, area)} className="learn-more-btn">
                {translations[language].therapeuticAreas.learnMore}
              </button>
            </div>
          </div>
        ))}
      </div>

      {selectedArea && (
        <div className="area-modal-overlay" onClick={closeModal}>
          <div className="area-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={closeModal}>×</button>
            <h2>{selectedArea.title}</h2>
            <h3>{selectedArea.subtitle}</h3>
            <div className="area-description">
              <section className="modal-section">
                <h4 className="section-title">{translations[language].therapeuticAreas.scientificBackground}</h4>
                <p>{selectedArea.scientificBackground}</p>
              </section>
              <section className="modal-section">
                <h4 className="section-title">{translations[language].therapeuticAreas.detailedMechanism}</h4>
                <p>{selectedArea.detailedMechanism}</p>
              </section>
              <section className="modal-section">
                <h4 className="section-title">{translations[language].therapeuticAreas.benefits}</h4>
                <ul className="benefits-list">
                  {selectedArea.benefits.map((benefit, index) => (
                    <li key={index}><span className="benefit-checkmark">✓</span> {benefit}</li>
                  ))}
                </ul>
              </section>
              <section className="modal-section">
                <h4 className="section-title">{translations[language].therapeuticAreas.procedure}</h4>
                <p>{selectedArea.procedure}</p>
              </section>
              <section className="modal-section">
                <h4 className="section-title">{translations[language].therapeuticAreas.expectedResults}</h4>
                <p>{selectedArea.expectedResults}</p>
              </section>
              <div className="modal-cta">
                <button className="modal-cta-btn" onClick={handleBookConsultation}>
                  {translations[language].therapeuticAreas.bookConsultation}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default TherapeuticAreas; 